import { MYSPACE } from "../services";
import fetchApi from "../utilityFunctions/customCreateApi2";

export const mySpaceGetFolder = async ({ query = {} }) => {
  const endpoint = MYSPACE?.FETCH_FOLDER_DATA || "";
  return await fetchApi({ endpoint, query });
};

export const mySpaceCreateFolder = async ({ body = {} }) => {
  const endpoint = MYSPACE?.CREATE_FOLDER_DATA || "";
  return await fetchApi({ endpoint, body });
};

export const mySpaceUploadFile = async ({ body = {}, query = {} }) => {
  const endpoint = MYSPACE?.UPLOAD_FILE || "";
  return await fetchApi({ endpoint, body, query });
};

export const mySpaceRenameAndMoveFolderFile = async ({ body = {}, params = {} }) => {
  const endpoint = MYSPACE?.RENAME_AND_MOVE_FOLDER_FILE || "";
  return await fetchApi({ endpoint, body, params });
};

export const mySpaceGetHeaders = async ({ params = {} }) => {
  const endpoint = MYSPACE?.GET_TABLE_HEADERS || "";
  return await fetchApi({ endpoint, params });
};
export const mySpaceData = async ({ params = {} }) => {
  const endpoint = MYSPACE?.GET_TABLE_BODY || "";
  return await fetchApi({ endpoint, params });
};

export const mySpaceAddField = async ({ body = {}, params = {} }) => {
  const endpoint = MYSPACE?.ADD_TABLE_COLUMN || "";
  return await fetchApi({ endpoint, body, params });
};

export const mySpaceAddUpdateCell = async ({ body = {}, params = {} }) => {
  const endpoint = MYSPACE?.ADD_UPDATE_TABLE_CELL || "";
  return await fetchApi({ endpoint, body, params });
};

export const mySpaceAddList = async ({ body = {} }) => {
  const endpoint = MYSPACE?.ADD_LIST || "";
  return await fetchApi({ endpoint, body });
};
export const mySpaceDeleteColumns = async ({ body = {}, params = {} }) => {
  const endpoint = MYSPACE?.BULK_DELETE_COLUMN || "";
  console.log(endpoint, body, params);
  return await fetchApi({ endpoint, body, params });
};

export const mySpaceAddColumnOptions = async ({ body = {}, params = {} }) => {
  const endpoint = MYSPACE?.ADD_TABLE_COLUMN_OPTIONS || "";
  return await fetchApi({ endpoint, body, params });
};

export const mySpaceCsvUpload = async ({ body = {}, query = {} }) => {
  const endpoint = MYSPACE?.CSV_UPLOAD || "";
  return await fetchApi({ endpoint, body, query });
};

export const mySpaceFileFolderDelete = async ({ params = {} }) => {
  const endpoint = MYSPACE?.DELETE_FILE_FOLDER || "";
  return await fetchApi({ endpoint, params });
};

export const mySpaceFieldOptions = async ({ params = {} }) => {
  const endpoint = MYSPACE?.FIELD_OPTIONS || "";
  return await fetchApi({ endpoint, params });
};

export const mySpaceFieldOptionsAddUpdate = async ({ params = {}, body = {} }) => {
  const endpoint = MYSPACE?.ADD_UPDATE_FIELD_OPTIONS || "";
  return await fetchApi({ endpoint, params, body });
};

export const mySpaceTableColumnUpdate = async ({ params = {}, body = {} }) => {
  const endpoint = MYSPACE?.UPDATE_TABLE_COLUMN_NAME || "";
  return await fetchApi({ endpoint, params, body });
};

export const mySpaceTableRowDelete = async ({ params = {}, body = {} }) => {
  const endpoint = MYSPACE?.DELETE_ROW_LIST_DATA || "";
  return await fetchApi({ endpoint, params, body });
};

export const mySpaceTableBulkUpdateListValue = async ({ params = {}, body = {} }) => {
  const endpoint = MYSPACE?.BULK_UPDATE_LIST || "";
  return await fetchApi({ endpoint, params, body });
};

export const mySpaceTableRowAddUpdate = async ({ params = {}, body = {} }) => {
  const endpoint = MYSPACE?.ROW_EDIT || "";
  return await fetchApi({ endpoint, params, body });
};

export const mySpaceTableSendAccess = async ({ body = {} }) => {
  const endpoint = MYSPACE?.SEND_ACCESS || "";
  return await fetchApi({ endpoint, body });
};

export const mySpaceTableGetUserAccess = async ({ params = {} }) => {
  const endpoint = MYSPACE?.GET_USER_ACCESS || "";
  return await fetchApi({ endpoint, params });
};

export const mySpaceTableUpdateUserAccess = async ({ params = {}, body = {} }) => {
  const endpoint = MYSPACE?.UPDATE_USER_ACCESS || "";
  return await fetchApi({ endpoint, params, body });
};

export const mySpaceTableRemoveUserAccess = async ({ params = {}, body = {} }) => {
  const endpoint = MYSPACE?.REMOVE_USER_ACCESS || "";
  return await fetchApi({ endpoint, params, body });
};

export const mySpaceTableSharedFileFolder = async ({ query = {} }) => {
  const endpoint = MYSPACE?.SHARED_FILE_FOLDER || "";
  return await fetchApi({ endpoint, query });
};

export const mySpacePersonList = async ({ params = {} }) => {
  const endpoint = MYSPACE?.PERSON_LIST || "";
  return await fetchApi({ endpoint, params });
};

export const mySpaceDeleteOption = async ({ params = {} }) => {
  const endpoint = MYSPACE?.DELETE_OPTION || "";
  return await fetchApi({ endpoint, params });
};

export const mySpaceGetPinnedList = async () => {
  const endpoint = MYSPACE?.GET_PINNED_LIST || "";
  return await fetchApi({ endpoint });
};
export const mySpaceMarkAsPin = async ({ body = {} }) => {
  const endpoint = MYSPACE?.MARKED_AS_PINNED || "";
  return await fetchApi({ endpoint, body });
};

export const mySpaceMarkAsUnpin = async ({ body = {} }) => {
  const endpoint = MYSPACE?.MARKED_AS_UNPINNED || "";
  return await fetchApi({ endpoint, body });
};
